import React, { Fragment, useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment, Visibility } from '@material-ui/icons';

//tabla y card components
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import { useParams } from 'react-router-dom';

import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';
import OrdmOrderDetailShared from '../OrderWebMovil/OrdmOrderDetailShared';
import ModalFull from 'components/Tvendo/Common/ModalFull';
import { Toasty, useToasty } from 'hooks/Toasty';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 110 },
  { Header: '#ID', accessor: 'ordm_order_id', width: 120 },
  { Header: 'Fecha órden', accessor: 'created_at', width: 150 },
  { Header: 'Cód. Cliente', accessor: 'CardCode', width: 140 },
  { Header: 'Nombre cliente', accessor: 'CardName' },
  { Header: 'Almacén', accessor: 'WhsName' },
  { Header: 'Uni. Comprometidas', accessor: 'commited_units', width: 190, align: 'center' },
  { Header: 'Monto', accessor: 'amount', width: 100, align: 'right' },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 }
];

export default WithApp(function ProductCommittedDetail(props) {
  const classes = useStyles();
  const { id, id2 } = useParams();

  const [notify, showNotify] = useToasty();
  const [pcDetails, setPCDetails] = useState({ details: [] });
  const [order, setOrder] = useState({ show: false, data: {} });
  const [valueSearch, setValueSearch] = useState({});

  async function listPCDetails() {
    if (!valueSearch.logi_warehouse_id) valueSearch.logi_warehouse_id = id2;
    let response = await wsFindBy(`ordm/product-consolidate/${id}`, valueSearch);
    if (response.success) {
      setPCDetails(response.data);
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    listPCDetails();
  }, [valueSearch]);

  return (
    <Fragment>
      <Toasty action={notify} />

      {order.show ? (
        <ModalFull title="Detalles" open={order.show} setOpen={() => setOrder({ show: false })}>
          <OrdmOrderDetailShared
            idOrder={order.data.ordm_order_id}
            cancelApprove
            reload={() => {
              setOrder({ show: false });
              listPCDetails();
            }}
          />
        </ModalFull>
      ) : undefined}

      <Card>
        <CardHeader icon>
          <CardIcon color="primary">
            <Assignment style={{ color: 'white' }} />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>
            Detalles del producto ({pcDetails.ItemCode} {pcDetails.ItemName})
          </h4>
        </CardHeader>
        <CardBody>
          <FilterCustom getFilter={setValueSearch} warehouse="N" />

          <ReactTable
            excelName="Marcas"
            defaultWidth={1200}
            formatDate="DD-MM-YYYY HH:mm:ss"
            columns={columns}
            data={pcDetails.details?.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <AllowedGuard permission={ConstantPermissions.ORDM_ORDERS_SHOW}>
                      <Button
                        justIcon
                        round
                        simple
                        color={props.themeContext.buttonColor}
                        onClick={() => setOrder({ show: true, data: item })}
                      >
                        <Visibility />
                      </Button>
                    </AllowedGuard>
                  </div>
                ),
                ordm_order_id: item.ordm_order_id,
                created_at: item.created_at,
                CardCode: item.CardCode,
                CardName: item.CardName,
                WhsName: `${item.WhsCode} - ${item.WhsName}`,
                commited_units: item.commited_units,
                amount: currency(item.amount),
                actions: ''
              };
            })}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
